module.exports = {
      id: "bondhushava-usage",
      viewBox: "0 0 225 61",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#bondhushava",
      toString: function () {
        return this.url;
      }
    }